const initState = {
    app: [],
    
    
  };
  
  // eslint-disable-next-line import/no-anonymous-default-export
  export default (state = initState, action) => {
    switch (action.type) {
      
      case "APPDATA": {
        return {...state, app:action?.payload }
      }  case "APPDESIGN": {
        return {...state, appDesign:action?.payload }
      }  
      case "APPLISTUI": {
        return {...state, listUI:action?.payload }
      }    
      
      // case "UPDATE_APP_TOKEN": {
      //   return {...state, RecentAppToken:action?.payload }
      // }  
      case "CURSOR": {
        return {...state, cursorHover:action?.payload }
      }  
      case "CURSORTEXT": {
        return {...state, cursorHoverText:action?.payload }
      }case "CURSORTEXTBG": {
        return {...state, cursorHoverTextBg:action?.payload }
      }  case "CURSORTEXTCOLOR": {
        return {...state, cursorHoverTextColor:action?.payload }
      }  case "CURSORTEXTDIRECTION": {
        return {...state, textDirection:action?.payload }
      }  case "MAINMENU": {
        return {...state, mainMenuStatus:action?.payload }
      }   case "routerLocation": {
        return {...state, routerLocation:action?.payload }
      }  
      
      case "LOGOUT": {
  
        localStorage.clear()
        return {...state, app:null }
         
          
        
      }
  
      
      default: {
        return state;
      }
    }
  };
  
  
  